import { type FieldError, type FieldErrors } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { ArrayFields, NamesAndPartiesTabFields } from '../types/fieldEnums';

import { additionalFieldsMapByTabSelector, selectedLicenseTypeNatureSelector } from '../store/selectors';
import { getConsignmentTabFields, getHeaderTabFields } from '../helpers/tabFields';
import { hasError } from '../../../helpers/hasError';

function useTabErrors(errors: FieldErrors) {
  const additionalFieldsByTab = useSelector(additionalFieldsMapByTabSelector);
  const licenseTypeNature = useSelector(selectedLicenseTypeNatureSelector);

  const tabErrors = {
    header:
      hasError(errors, getHeaderTabFields(licenseTypeNature)) ||
      hasError(errors.additionalFields as Record<string, FieldError>, additionalFieldsByTab.HEADER) ||
      hasError(errors.dbOptionAdditionalFields as Record<string, FieldError>, additionalFieldsByTab.HEADER),
    namesAndParties:
      hasError(errors, NamesAndPartiesTabFields) ||
      !!errors?.[ArrayFields.beneficiaries] ||
      hasError(errors.additionalFields as Record<string, FieldError>, additionalFieldsByTab.NAMES_AND_PARTIES) ||
      hasError(errors.dbOptionAdditionalFields as Record<string, FieldError>, additionalFieldsByTab.NAMES_AND_PARTIES),
    consignment:
      hasError(errors, getConsignmentTabFields()) ||
      hasError(errors.additionalFields as Record<string, FieldError>, additionalFieldsByTab.CONSIGNMENT) ||
      hasError(errors.dbOptionAdditionalFields as Record<string, FieldError>, additionalFieldsByTab.CONSIGNMENT),
    items: !!errors?.[ArrayFields.items],
    attachedDocuments:
      !!errors?.[ArrayFields.attachedDocuments] ||
      hasError(errors.additionalFields as Record<string, FieldError>, additionalFieldsByTab.ATTACHED_DOCUMENT) ||
      hasError(errors.dbOptionAdditionalFields as Record<string, FieldError>, additionalFieldsByTab.ATTACHED_DOCUMENT),
    fees: !!errors?.[ArrayFields.fees],
  };

  return tabErrors;
}

export default useTabErrors;
